/**
 * CA Auth OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserItemDto { 
    defaultProjectKey?: string;
    name?: string;
    phones?: Array<string>;
    refreshTokenNotValidCount?: number;
    refreshTokenValidCount?: number;
    username?: string;
}

